module.exports = __webpack_public_path__ + "static/img/face.6676b3b9.png";